/** Spanish dialogue guillemets → curly double quotes for clearer reading in the app. */
export function formatSpanishGuillemetsForDisplay(text: string): string {
  return text.replace(/«/g, '\u201C').replace(/»/g, '\u201D');
}

export function textHasSpanishGuillemets(text: string): boolean {
  return text.includes('«') || text.includes('»');
}
